import eventBus from "../services/event-bus";
import { elementExists } from "../utils";
const CartCount = function ($selector = '[sh-cart-count]') {
  const _this = {};

  _this.classes = {
    empty: 'empty'
  }

  _this.elements = document.querySelectorAll($selector);

  if (elementExists(_this.elements)) {
    eventBus.on(eventBus.types.CartUpdated, (event) => {
      _this.elements.forEach(el => {
        if( Shopify.cartService.cart.item_count == 0 ){
          el.classList.add(_this.classes.empty);
        }else{
          el.classList.remove(_this.classes.empty);
        }
        el.innerText = Shopify.cartService.cart.item_count
      });
    });
  }
}

export default CartCount;

